import React, { useState } from 'react';
import { Layout, Spin } from 'antd';
import { SideBarIcon, StorageUtils } from 'utils';
import { useAuth } from '../../auth/AuthProvider';
import SearchWebsite from '../../components/SearchWebsite/SearchWebsite';
import { ResponsiveView } from '../../components';

import LanguagePicker from './LanguagePicker/LanguagePicker';
import './MainHeader.scss';
import CustomerPicker from './CustomerPicker/CustomerPicker';
import LogoutDropdown from './LogoutDropdown/LogoutDropdown';

interface IMainHeaderProps {
  collapsed: boolean;
  toggle: () => void;
}

const MainHeader: React.FC<IMainHeaderProps> = ({ collapsed, toggle }) => {
  const [customer, _setCustomer] = useState<string>(StorageUtils.getCustomerId() as string);
  const isCustomerSet = customer && customer !== 'null';
  const { user } = useAuth();

  // Create a profile-like object for LanguagePicker compatibility
  const userProfile = user
    ? {
        id: user.id,
        username: user.loginName,
        email: user.email,
        firstName: user.firstName || user.displayName.split(' ')[0] || '',
        lastName: user.lastName || user.displayName.split(' ').slice(1).join(' ') || '',
      }
    : null;

  return (
    <Layout.Header className="site-layout-background main-header">
      <ResponsiveView
        onMobile={
          <div className="main-header-left-container">
            <span
              className={`trigger${collapsed ? ' active' : ''}`}
              onClick={toggle}
              role="button"
              tabIndex={0}
            >
              <SideBarIcon />
            </span>
          </div>
        }
        onDesktop={
          <>
            <div className="main-header-left-container">
              <span
                className={`trigger${collapsed ? ' active' : ''}`}
                onClick={toggle}
                role="button"
                tabIndex={0}
              >
                <SideBarIcon />
              </span>
              <CustomerPicker customerChangeCallback={undefined} />
              <SearchWebsite />
            </div>
            <div className="main-header-right-container">
              {isCustomerSet ? <LanguagePicker user={userProfile} /> : <Spin size="small" />}
              <LogoutDropdown />
            </div>
          </>
        }
      />
    </Layout.Header>
  );
};

export default MainHeader;
